module.exports = __webpack_public_path__ + "img/20230803093809298pj0.39e02770.jpg";